// extracted by mini-css-extract-plugin
export default {"overlaySpinner":"OverlaySpinner--overlaySpinner--Bl1QB","overlay":"OverlaySpinner--overlay--06pb-"};